<template>
  <am-dialog :open="isOpen" class="am-hint-dialog-window" @closed="onClose">
    <am-card class="am-hint-dialog">
      <am-card-header class="am-hint-dialog-header">
        <am-typography variant="subtitle1" color="medium">
          <slot name="title" />
        </am-typography>
        <div class="close-icon">
          <am-icon-button @click="onClose" class="am-hint-dialog-close" icon="close" />
        </div>
      </am-card-header>
      <am-card-body class="am-hint-dialog-body">
        <am-typography variant="body2" color="medium">
          <slot name="text" />
        </am-typography>
      </am-card-body>
    </am-card>
  </am-dialog>
</template>

<script>
import { AmCard, AmCardHeader, AmCardBody } from "../Card";
import { AmDialog } from "../Dialog";
import { AmIconButton } from "../IconButton";
import { AmTypography } from "../Typography";

export default {
  inheritAttrs: false,
  components: {
    AmCard,
    AmCardHeader,
    AmCardBody,
    AmDialog,
    AmIconButton,
    AmTypography
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.am-hint-dialog-window {
  .mdc-dialog__container {
    align-items: flex-end;
    transform: initial;
  }

  .mdc-dialog__surface,
  .mdc-dialog__container {
    max-width: 100%;
    width: 100%;
  }

  .mdc-dialog__surface,
  .am-hint-dialog {
    border-radius: 8px 8px 0 0;
  }
}
.am-hint-dialog-header {
  padding: 0;

  .am-card-header-title {
    padding: 10px 16px;
    background-color: #f6f9fe;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
}
.am-hint-dialog-body {
  padding: 16px;
}
.am-hint-dialog-close {
  width: 32px;
  height: 32px;
  padding: 4px;
  display: block;
}
</style>
